<template>
    <el-dialog
        width="600px"
        title="不再运营原因"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" size="mini" label-width="130px"  :inline="true">
            <el-form-item label="不再运营原因：">
                <el-input type="textarea" v-model="formData.no_season" :rows="5"></el-input>
            </el-form-item>
        </el-form>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">修 改
            </el-button>
        </el-row>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import {operating_asin_manager_index_update_field} from '@/api/advAnalys/advAnalys.js'

    export default {
        name: 'updatePatent',
        data() {
            return {
                visible: false,
                loading: false,
                formData: {},
                rules: {},

                fileList: [],
                obj: {},
                disabled: false,
                filesize: 0,
                value: '',
                file_data: null
            }
        },
        methods: {
            openModal(data) {
                const tempData = JSON.parse(JSON.stringify(data))
                this.formData = tempData
                this.visible = true
            },
            submitForm(flag) {
                this.loading = true
                api.operating_asin_manager_index_update_field({
                    id: this.formData.id,
                    no_season: this.formData.no_season,
                }).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({message: '修改成功', type: 'success'})
                        this.handleClose(true)
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                    this.$message({type: 'error', message: '网络出现问题，请刷新页面！'})
                })
            },

            // 关闭弹窗
            handleClose(isshow = false) {
                this.visible = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>

